jQuery_T4NT(document).ready(function ($) {
  var window_W = $(window).width();
  if (window.Swiper) {
    const progressCircle = document.querySelector(".autoplay-progress svg");
    const progressContent = document.querySelector(".autoplay-progress span");
    const swiper = new Swiper(".swiper", {
      // Optional parameters
      loop: true,
      autoplay: true,
      effect: "cards",

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // And if we need scrollbar

      on: {
        autoplayTimeLeft(s, time, progress) {
          progressCircle.style.setProperty("--progress", 1 - progress);
          progressContent.textContent = `${Math.ceil(time / 1000)}s`;
        },
      },
    });
  }
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  function getScrollBarWidth() {
    let el = document.createElement("div");
    el.style.cssText = "overflow:scroll; visibility:hidden; position:absolute;";
    document.body.appendChild(el);
    let width = el.offsetWidth - el.clientWidth;
    el.remove();
    return width;
  }
  $("body").css("--scroll-w", getScrollBarWidth() + "px");
  $('[data-toggle-class="show-search"]').on("click", function () {
    $("body").css("overflow", "hidden");
  });
  $('[data-toggle-class="show-search"][data-drawer-close]').on(
    "click",
    function () {
      $("body").css("overflow", "");
    }
  );
  $(document).on("mouseenter", ".t4s-grid .--grid-item", function () {
    $(".t4s-grid .--grid-item").removeClass("onhover");
    $(this).addClass("onhover");
  });
  $(document).on("click", ".t4s-grid .--grid-item", function () {
    $(".t4s-grid .--grid-item").removeClass("onhover");
    $(this).addClass("onhover");
  });

  var op = 0,
    op10 = 0,
    lg_w_scroll = lg_w;
  if ($(window).scrollTop() > 90) {
    op = 1;
    op10 = 0.1;
  }
  $(".t4s-section-header").css({ "--op": op, "--op10": op10 });
  $(".header__sticky-logo").css({ width: lg_w_scroll + "px" });

  $(window).on("resize", function () {
    window_W = $(window).width();
  });
  $(window).scroll(function () {
    // Show hide scrolltop button
    var lgsticky_w = window_W < 992 ? lgm_w : lgs_w;
    if ($(this).scrollTop() > 90) {
      op = 1;
      op10 = 0.1;
      lg_w_scroll = lgsticky_w;
    } else if ($(this).scrollTop() == 0) {
      op = 0;
      op10 = 0;
      lg_w_scroll = lg_w;
    } else {
      op = 1 - $(this).scrollTop() / 90;
      op10 = 0.1 - $(this).scrollTop() / 90;
      lg_w_scroll = lgsticky_w + $(this).scrollTop() / 90;
    }
    $(".t4s-section-header").css({ "--op": op, "--op10": op10 });
    $(".header__sticky-logo").css({ width: lg_w_scroll + "px" });
  });

  $(document)
    .on("click", ".t4s-only_icon_true .t4s-mb-nav__icon-float", function (e) {
      e.preventDefault();
      console.log(1);
      // $('.t4s-navv-parent-title').html("<span>"+$(this).attr("data-title-parent")+"</span>");
      var id_child = $(this).attr("data-child");
      $(id_child).addClass("is--opend");
      $(this).parents(".t4s-menu-item").first().addClass("is--opend");
      if (id_child.indexOf("item_grandchild") >= 0) {
        $(".t4s-drawer-menu__back")
          .css({ opacity: 1 })
          .attr({ "data-grandchild": id_child });
      } else {
        $(".t4s-drawer-menu__back")
          .css({ opacity: 1 })
          .attr({ "data-child": id_child });
      }
    })
    .on("click", ".t4s-title-parent", function (e) {
      e.preventDefault();
      $(this).parent().removeClass("is--opend");
    })
    .on("click", ".t4s-only_icon_false", function (e) {
      // $('.t4s-navv-parent-title').html("<span>"+$(this).attr("data-title-parent")+"</span>");
      e.preventDefault();
      console.log(2);
      $this = $(this).find(".t4s-mb-nav__icon-float");
      const id_chil = $this.attr("data-child");
      $(id_chil).addClass("is--opend");
      $this.parents(".t4s-menu-item").first().addClass("is--opend");
      if (id_chil.indexOf("item_grandchild") >= 0) {
        $(".t4s-drawer-menu__back")
          .css({ opacity: 1 })
          .attr({ "data-grandchild": id_chil });
      } else {
        $(".t4s-drawer-menu__back")
          .css({ opacity: 1 })
          .attr({ "data-child": id_chil });
      }
    })
    .on("click", ".t4s-drawer-menu__back", function (e) {
      var id_child = $(this).attr("data-child");
      var id_gchild = $(this).attr("data-grandchild");
      if (id_gchild !== "") {
        $(id_gchild).removeClass("is--opend");
        $(this).attr("data-grandchild", "");
      } else {
        $(id_child).removeClass("is--opend");
        $(this).attr("data-child", "");
        $(".t4s-drawer-menu__back").css({ opacity: 0 });
      }
    });

  $(document).on("change", "#CountryList", function (event) {
    $(this).parents("form").submit();
  });

  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });

  /**
   * Toggle class
   */
  $(document).on("click", "[data-toggle-class]", function (e) {
    var _class = $(this).attr("data-toggle-class"),
      trigger = $(this).attr("data-toggle-trigger");
    $(this).toggleClass(_class);
    $(trigger).toggleClass(_class);
  });
  // $(document).on("mouseleave", ".show-search #t4s-search-hidden", function(e) {
  // 	$('.t4s-site-nav__search .t4s-drawer__close').trigger('click');
  // })
  // $(document).on("mouseenter", "body:not(.show-search) .t4s-icon--search", function(e) {
  // 	$(this).trigger('click');
  // })

  var $bar = $(".t4s-announcement-bar"),
    num_ver = $bar.attr("data-ver"),
    themeName = T4Sconfigs.theme,
    txt_ver = "t4s_announcement_" + themeName + "_" + num_ver;
  if ($bar.length == 0 || CookiesT4.get(txt_ver) == "closed") {
    $("body").css("--announcement-height", "0px");
  }
  $(document).on("click", ".t4s-announcement-bar__close", function (e) {
    $("body").css("--announcement-height", "0px");
  });

  // var $atc = $(".template-product .t4s-product-form__buttons");
  // if ($atc.length !== 0 && window_W < 768) {
  //   const observer = new IntersectionObserver(
  //     (entries, observer) => {
  //       entries.forEach((entry) => {
  //         if (entry.boundingClientRect.y < 0) {
  //           return;
  //         }
  //         if (entry.intersectionRatio < 1) {
  //           // $atc.addClass("sticky");
  //           // console.log("add class");
  //           $atc.removeClass("sticky");
  //         } else if (entry.intersectionRatio === 1) {
  //           // $atc.removeClass("sticky");
  //           // console.log("remove class");
  //           $atc.addClass("sticky");
  //         }
  //       });
  //     },
  //     {
  //       threshold: 1,
  //       rootMargin:'0px 0px -200px 0px'
  //     }
  //   );
  //   observer.observe($atc[0]);
  // }
});

// ================================
// loop / pause video
// ================================

$(document).on("click", ".t4s-loop-pause", function () {
  $(this).toggleClass("pause");
  let video = $(this).parents($(this).data("trigger")).find("video");
  $(this).hasClass("pause") ? video.trigger("pause") : video.trigger("play");
});

// ================================
// fix height video gallery
// ================================

class videoGallery extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[video-gallery-slider]");
    this.video = this.querySelector("[video-galerry-vid]");
    if (!this.slider || !this.video) {
      return;
    }
    this.fixHeight();
    window.addEventListener("resize", () => {
      this.fixHeight();
    });
  }
  fixHeight() {
    let self = this;
    let item_h = self.querySelector("video").offsetHeight;
    // self.slider.setAttribute('style', `height: ${item_h}px !important;`);
    // self.video.setAttribute('style', `--t4s-aspect-ratio: ${item_h}px !important;`)
    // console.log(self.slider.querySelector("[get_ratio]"));
    // self.slider
    //   .querySelector("[get_ratio]")
    //   .setAttribute("style", `--aspect-ratioapt: ${item_h}px;`);
    if (window.innerWidth > 767) {
      self
        .querySelector(".rlc-cardstack")
        .setAttribute("style", `height: ${item_h}px;`);
    } else {
      self
        .querySelector(".rlc-cardstack")
        .setAttribute("style", `height: ${item_h - 150}px;`);
    }
  }
}
customElements.define("video-gallery", videoGallery);
